var exports = {
  "zr": "xe533113f--f29df8--root",
  "GS": "xe533113f--f29df8--fill",
  "q2": "xe533113f--f29df8--shine",
};

module.exports = exports;
